module.exports = __webpack_public_path__ + "static/img/10.08f4b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/10.png
// module id = mqWB
// module chunks = 0